import { render, staticRenderFns } from "./TermsOfServiceForMerchant.pug?vue&type=template&id=1b19b2b0&lang=pug&"
import script from "./TermsOfServiceForMerchant.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceForMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports